<template>
  <v-container id="user-alerts-container">
    <div>
      <h3>
        AutoResolve Settings
      </h3>
      <div>
        By default AutoResolve will continue to automatically solve noise issues for you and<br>
        messages sent to guests can be viewed in the noise graph.
      </div>
      <div>
        <a
          class="info-link"
          target="_blank"
          href="https://help.noiseaware.io/hc/en-us/articles/4406268412947-AutoResolve"
        >
          <v-icon
            size="small"
            color="muted"
            class="mr-1"
          >
            $faInfoCircle
          </v-icon>How does AutoResolve work?
        </a>
      </div>
      <setting-tooltip :enabled="!settingsEnabled">
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
          >
            <toggle
              :value="autoResolve"
              :disabled="!settingsEnabled"
              @toggle="value => handleNotificationSettingsChange({updated: 'addAutoResolveMessageMirroringNotifications', value: value || false})"
            >
              <template v-slot:label>
                <div>
                  <h6>
                    <span class="new">
                      new!
                    </span>AutoResolve Engage
                  </h6>
                  Receive notifications when escalation messages are sent to a guest.
                </div>
              </template>
            </toggle>
          </div>
        </template>
        <span v-if="!settingsEnabled">
          This field cannot be edited because this user belongs to multiple organizations
        </span>
      </setting-tooltip>
    </div>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Toggle from '../base/Toggle.vue'
  import SettingTooltip from './SettingTooltip'

  export default {
    name: 'AutoResolveSetting',
    components: { Toggle, SettingTooltip },
    props: {
      savedUserData: {
        type: Object,
        default: () => {},
      },
      autoResolve: Boolean,
    },
    computed: {
      ...mapGetters({
        currentUser: 'Users/currentUser',
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canAdminUser: 'Permissions/canAdminUser',
        isUserSelf: 'Permissions/isUserSelf',
        isInternal: 'Permissions/isInternal',
      }),
      orgId () {
        return this.currentSelectedOrg?.id
      },
      settingsEnabled () {
        const isSingleOrg = this.savedUserData.orgs?.length === 1
        return this.isUserSelf ||
          (this.isInternal && this.orgId) ||
          (this.canAdminUser(this.savedUserData, this.orgId) && isSingleOrg)
      },
    },
    methods: {
      handleNotificationSettingsChange ({ updated, value }) {
        this.$store.dispatch('Users/updateUserNotificationSettings', {
          updated,
          value,
          userId: this.savedUserData.id,
          orgId: this.savedUserData.orgs[0].id,
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
#user-alerts-container {
  display: flex;
  padding: 34px 49px;
  flex-direction: column;
  justify-content: space-between;
  min-height: 400px;
}
.new {
  background-color: $success;
  border-radius: 4px;
  color: white;
  text-transform: uppercase;
  font-size: 13px;
  display: inline-block;
  padding: 0 6px;
  font-family: 'Lato';
  margin-right: 8px;
  line-height: 18px;
  font-weight: 400;
}
h3 {
  line-height: 29px;
}

.info-link {
  color: $muted;
  text-decoration: none;
}
</style>
